import client from '../client';

const BASE = '/api/feature-categories';

/** Get all feature categories */
export function createFeatureCategory(payload) {
  return client.post(`${BASE}`, payload).then(res => res.data);
}

/** Get all feature categories */
export function getFeatureCategories(includeInactive = false) {
  const params = includeInactive ? { includeInactive } : {};
  return client.get(`${BASE}`, { params }).then(res => res.data);
}

/** Get feature category count */
export function getFeatureCategoryCount() {
  return client.get(`${BASE}/count`).then(res => res.data);
}

/** Get feature category by id */
export function getFeatureCategoryById(id) {
  return client.get(`${BASE}/${id}`).then(res => res.data);
}

/** Update feature category */
export function updateFeatureCategory(id, payload) {
  return client.put(`${BASE}/${id}`, payload).then(res => res.data);
}

/** Delete feature category */
export function deleteFeatureCategory(id) {
  return client.delete(`${BASE}/${id}`).then(res => res.data);
}